import { databases, DATABASE_ID, COLLECTION_ID_CONCRETE_POLES_DELIVERIES } from '../config/appwrite';
import { ID, Query } from 'appwrite';

const parseDeliveryState = (raw) => {
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw || '{}') : raw || {};
    return {
      deliveryDates: Array.isArray(parsed.deliveryDates) ? parsed.deliveryDates : [],
      deliveryNumbers: Array.isArray(parsed.deliveryNumbers) ? parsed.deliveryNumbers : [],
      deliveryData:
        parsed.deliveryData && typeof parsed.deliveryData === 'object' ? parsed.deliveryData : {}
    };
  } catch {
    return { deliveryDates: [], deliveryNumbers: [], deliveryData: {} };
  }
};

/**
 * All concrete poles delivery rows keyed by purchase order document id ($id).
 */
export const fetchConcretePolesDeliveriesStateMap = async () => {
  const map = {};
  let cursor = null;
  const limit = 100;
  for (let page = 0; page < 50; page += 1) {
    const queries = [Query.limit(limit), Query.orderDesc('$createdAt')];
    if (cursor) queries.push(Query.cursorAfter(cursor));
    const response = await databases.listDocuments(
      DATABASE_ID,
      COLLECTION_ID_CONCRETE_POLES_DELIVERIES,
      queries
    );
    for (const doc of response.documents) {
      const poId = doc.purchaseOrderId;
      if (!poId) continue;
      map[poId] = parseDeliveryState(doc.deliveryState);
    }
    if (response.documents.length < limit) break;
    cursor = response.documents[response.documents.length - 1].$id;
  }
  return map;
};

export const upsertConcretePolesDelivery = async (purchaseOrderId, state) => {
  if (!purchaseOrderId || !state) return;
  const deliveryState = JSON.stringify({
    deliveryDates: state.deliveryDates || [],
    deliveryNumbers: state.deliveryNumbers || [],
    deliveryData: state.deliveryData || {}
  });

  const existing = await databases.listDocuments(DATABASE_ID, COLLECTION_ID_CONCRETE_POLES_DELIVERIES, [
    Query.equal('purchaseOrderId', purchaseOrderId),
    Query.limit(1)
  ]);

  if (existing.documents.length > 0) {
    await databases.updateDocument(
      DATABASE_ID,
      COLLECTION_ID_CONCRETE_POLES_DELIVERIES,
      existing.documents[0].$id,
      { deliveryState }
    );
  } else {
    await databases.createDocument(
      DATABASE_ID,
      COLLECTION_ID_CONCRETE_POLES_DELIVERIES,
      ID.unique(),
      {
        purchaseOrderId,
        deliveryState
      }
    );
  }
};
